import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import ModalStyle from "@/styles/components/modal/add-assessment/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import Tooltip from "react-simple-tooltip";
import Phone from "public/icons/call2.svg";
import Tech from "public/icons/technical.svg";
import Video from "public/icons/video.svg";
import Face from "public/icons/user.svg";
import VideoQA from "public/icons/videoqa.svg";
import { components } from "react-select";
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Autosuggest from "react-autosuggest";
import PlaceAutoComplete from "react-places-autocomplete";
import { Loading } from "@/components/loading";
import Exclamation from "public/icons/exclamation.svg";
import PracticeExclamation from "public/new-icons/info-icon.svg";
import {
  CustomAutocompleteError,
  Field,
  FieldArray,
  Form,
  Formik,
  FormikControl,
  useState,
  INTERVIEW_TYPES,
  useRef,
} from "@/imports-files/common/common";
import {
  AssessmentDropZone,
  EXTENSION_COMMON,
  DragDropContext,
  Droppable,
  Draggable,
} from "@/imports-files/pages/clients/recruitments/manage-assessment";
import {
  Page,
  Image,
  InputError,
  InputText,
  useTranslation,
  isCustomLink,
  useRouter,
  useEffect,
  Deleteicon,
  AddInterviewManualAction,
} from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import { setFilledDate } from "@/imports-files/components/job-filters";
import { CONSTANTS } from "@/imports-files/components/model/setup-video-qa";
import ClientDashboard from "src/layouts/ClientDashboard";
import { reviewAutomationEmail } from "@/imports-files/pages/clients/candidates/kanban";
import {
  initialStageValues,
  showHideButtonValue,
  onAutomationChange,
  onSuggestionSelection,
  onSuggestionsFetchRequested,
  renderInputComponent,
  renderAutomationModalInputComponent,
  renderSuggestion,
  shouldRenderSuggestions,
  handleKeyDown,
  handleDelete,
  handleInterviewFormSubmit,
  toggleDisabled,
  runAutomations,
  interviewTypeHeader,
  TechTestAction,
  cursorNone,
  validations,
  renderLabel,
  handleVideoQAFormSubmit,
  setUpTechTest,
  defaultTestDetail,
  VideoQaAction,
  userHash,
  setUpVideoQAMember,
  isLocationDisabled,
  JOB_STAGES,
  CustomToastrAction,
} from "@/imports-files/pages/clients/jobs/automations";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import AddIcon from "public/icons/thick-plus.svg"

export function AutomationModal(props) {
  const { t, i18n } = useTranslation();
  var initialValues = props.currentStage;
  var currentStage = props.currentStage;
  const [current_interview_type, setCurrentInterviewType] = useState(
    currentStage?.interview_type
  );
  initialValues.job_meeting_details_attributes?.map(
    (x) => (x.interview_type = initialValues.interview_type)
  );
  initialValues.default_location =
    initialValues.job_meeting_details_attributes[0]?.location_attributes
      ?.full_address || currentStage?.default_location;
  initialValues.place_id =
    initialValues.job_meeting_details_attributes[0]?.location_attributes
      ?.place_id || currentStage?.place_id;
  const [tests, setTests] = useState([]);
  const techTestAction = new TechTestAction(setTests);
  const videoQaAction = new VideoQaAction(setTests);
  if (currentStage.interview_type == INTERVIEW_TYPES.TECHTEST)
    initialValues = setUpTechTest(initialValues, techTestAction, currentStage, t);
  if (currentStage.interview_type == INTERVIEW_TYPES.VIDEOQA)
    initialValues = setUpVideoQAMember(initialValues, currentStage);
  const { Option } = components;
  const setBtnPopup = props.setBtnPopup;
  const setOnLoadValues = props.setOnLoadValues;
  const platforms = props.currentStage.platforms;
  const [interviewStageCount, setInterviewStageCount] = useState(
    currentStage.job_meeting_details_attributes.length
  );
  const [users, setUsers] = useState([]);
  const [totalDuration, setTotalDuration] = useState(
    currentStage.job_meeting_details_attributes
      .map((x) => x.duration)
      .reduce((a, b) => {
        a = parseInt(a) || 0;
        b = parseInt(b) || 0;
        return a + b;
      }, 0)
  );
  const router = useRouter();
  const [stageEmail, setStageEmail] = useState(
    initialStageValues(initialValues)
  );
  const editable = props.editable;
  const [isLoading, setLoading] = useState(true);
  const [isDisabled, setDisabled] = useState(false);
  const [showHideButton, setShowHideButton] = useState(
    showHideButtonValue(initialValues)
  );
  const interviewTypes = props.currentStage.interview_types;
  const [disabledAddMoreQuestion, setDisabledAddMoreQuestion] = useState(false);
  const [deleteQuestionList, setDeleteQuestionList] = useState([]);
  const [flagForRender, setFlagForRender] = useState(0);
  const addInterviewManualAction = new AddInterviewManualAction(
    setFlagForRender,
    deleteQuestionList,
    setDeleteQuestionList,
    setDisabledAddMoreQuestion
  );
  const [languageListing, setLanguageListing] = useState(
    addInterviewManualAction.setLanguageList(props.currentStage.language_list)
  );
  const [techTest, setTechTest] = useState(
    initialValues.job_test_detail_attributes?.test_name
      ? initialValues.job_test_detail_attributes.test_name
      : ""
  );
  const [techStageEmail, setTechStageEmail] = useState({
    value: "",
    error: "",
  });
  const [validationData, setValidationData] = useState({
    type: initialValues.job_test_detail_attributes?.test_type || "TestLibrary",
    test_id:
      initialValues.job_test_detail_attributes?.test_id?.toString() || "",
  });
  const {parentData, setParentData, currentIndex } = props
  const [buttonState, setButtonState] = useState("");
  const [uploadFileText, setUploadFileText] = useState("Upload a file");
  const customToastrAction = new CustomToastrAction();
  const formRef = useRef(null);
  useEffect(() => {
    (async () => {
      setLoading(false);
    })();
  }, []);

  if (isLoading) {
    return "";
  }

  function interviewSwitchButton(type) {
    switch (type) {
      case INTERVIEW_TYPES.PHONE:
        return <Phone />;
      case INTERVIEW_TYPES.TECHTEST:
        return <Tech className="techIcon" />;
      case INTERVIEW_TYPES.VIDEO:
        return <Video />;
      case INTERVIEW_TYPES.FACE2FACE:
        return <Face className="faceIcon" />;
      case INTERVIEW_TYPES.VIDEOQA:
        return <VideoQA className="videoQAIcon"/>;
      default:
        return "";
    }
  }

  const IconOption = (props) => {
    return (
      <Option {...props}>
        <div className={PageStyle.Selectimg}>
          <img
            src={`/images/pages/automation/${props.data.label
              .replace(" ", "_")
              .toLowerCase()}.png`}
            style={{
              marginRight: 12,
              width: 20,
              height: 20,
              verticalAlign: "middle",
            }}
            alt={props.data.label}
          />
          {props.data.label}
        </div>
      </Option>
    );
  };

  function gridClass(current_interview_type) {
    return current_interview_type == INTERVIEW_TYPES.VIDEO
      ? PageStyle.SetupPopup__ContentGrid
      : AutomationStyle.AutomationPopup__ContentGridPhone;
  }
  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal} AutomationPopup AddInterview`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div className={`${FormModalStyle.Modal__Container__Heading__Close}`}>
             <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading} mb0`}>
              {`${interviewTypeHeader(current_interview_type, t).header}`}
            </h1>
            <div
              className={`${FormModalStyle.Modal__Container__CloseSection}`}
              onClick={() => setBtnPopup(false)}>
              <Close />
            </div>
          </div>

          <div className={FormModalStyle.Modal__Container__ContentSection}>
            <div
              className={
                FormModalStyle.Modal__Container__ContentSection__Description
              }
            >{`${interviewTypeHeader(current_interview_type, t).subheader}`}</div>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validations(
              current_interview_type,
              validationData
            )}
            onSubmit={async (values, actions) => {
              if (
                validationData.type == "Assessment" &&
                validationData.test_id == "upload_new_test"
              ) {
                values.save_and_continue =
                  buttonState == "save_and_continue" ? true : false;
              }
              // setLoading(true);
              if (props.sendAutomation) {
                runAutomations({
                  setJobData: props.setJobData,
                  selectedCards: props.automationActions,
                  router: router,
                  job_id: props.jobData.id,
                  fromPopup: true,
                  values: values,
                  setBtnPopup: setBtnPopup,
                  setSendAutomation: props.setSendAutomation,
                  filterData: props.filterData,
                  reviewKey: props.reviewKey,
                  setDisabled: setDisabled,
                  deleteQuestionList: deleteQuestionList,
                  from: props.from,
                  setInitialData: props.setInitialData,
                });
              } else {
                const errors = await handleInterviewFormSubmit(
                  values,
                  router,
                  currentStage.id,
                  setBtnPopup,
                  setOnLoadValues,
                  props.from,
                  props.jobData,
                  props.setJobData,
                  setDisabled,
                  deleteQuestionList,
                  t
                );
                actions.setErrors(errors);
              }
            }}
          >
            {(formik) => (
              <Form style={{ width: "100%" }}>
                <div
                  className={
                    FormModalStyle.Modal__Container__ContentSection__FormContainer
                  }
                >
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block__ToggleContainer}`}
                  >
                   {t('modal:input:automation')}:
                    {formik.values.disabled_automation?.is_disabled ? (
                      <Tooltip
                        content={formik.values.disabled_automation?.hover_text}
                        background={"#203040"}
                        radius={20}
                        padding={8}
                        placement="bottom"
                        fontSize="12px"
                        className='SimpleTooltip'
                      >
                        <p className={`tooltipwidthinterview140`}>
                          <label className={`automationswitch`}>
                            <input
                              type="checkbox"
                              name={"automation"}
                              defaultChecked={formik.values.automation}
                              disabled={
                                formik.values.disabled_automation?.is_disabled
                              }
                              onChange={(event) => {
                                formik.setFieldValue(
                                  "automation",
                                  event.target.checked
                                );
                              }}
                            />
                            <div
                              className={`automationslider automationround ${toggleDisabled(
                                !formik.values.disabled_automation?.is_disabled
                              )}`}
                            >
                              {/*<span className={`automationon`}>On</span>
                              <span className={`automationoff`}>Off</span>*/}
                            </div>
                          </label>
                        </p>
                      </Tooltip>
                    ) : (
                      <label className={`automationswitch`} style={{marginBottom: 0 }}>
                        <input
                          type="checkbox"
                          name={"automation"}
                          defaultChecked={formik.values.automation}
                          onChange={(event) => {
                            formik.setFieldValue(
                              "automation",
                              event.target.checked
                            );
                          }}
                        />
                        <div className={`automationslider automationround`}>
                          {/*<span className={`automationon`}>On</span>
                          <span className={`automationoff`}>Off</span>*/}
                        </div>
                      </label>
                    )}
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <label
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                    >
                      {t('jobs:stages:interview:type')}
                      {currentStage.stage == JOB_STAGES.INTERVIEW ? "*" : ""}
                    </label>
                    <div
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__IconContainer}`}
                    >
                      {interviewTypes.map((x, interviewIndex) => {
                        return (
                          <div
                            className={
                              FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons
                            }
                            key={`interview_type_${interviewIndex}`}
                          >
                            <Tooltip
                              background={"#203040"}
                              radius={50}
                              placement="bottom"
                              fontSize="12px"
                              content={x.display_name}
                              key={x.name}
                              padding={12}
                              className='SimpleTooltip'
                            >
                              <p
                                className={`${PageStyle.Interview__IconsType} tooltipwidthinterview100`}
                              >
                                <input
                                  type="radio"
                                  name="interview_type_id"
                                  id={`icon${interviewIndex}`}
                                  checked={
                                    formik.values.interview_type_id == x.id
                                  }
                                  onClick={async () => {
                                    let old_interview_type =
                                      formik.values.interview_type;
                                    if (
                                      old_interview_type &&
                                      currentStage.stage ==
                                        JOB_STAGES.SCREENING &&
                                      old_interview_type == x.name
                                    ) {
                                      if (formik.values.automation) {
                                        customToastrAction.setNormalToastr(
                                          "Please turn the automation off to deselect interview type.",
                                          "warning"
                                        );
                                      } else {
                                        formik.setFieldValue(
                                          "interview_type_id",
                                          null
                                        );
                                        formik.setFieldValue(
                                          "interview_type",
                                          null
                                        );
                                        currentStage.interview_type = null;
                                        await setCurrentInterviewType(null);
                                        formik.values.job_meeting_details_attributes.map(
                                          (x) => {
                                            x._destroy = true;
                                            return x;
                                          }
                                        );
                                      }
                                    } else {
                                      if (
                                        old_interview_type &&
                                        old_interview_type == x.name
                                      ) {
                                        return;
                                      }
                                      formik.setFieldValue(
                                        "interview_type_id",
                                        x.id
                                      );
                                      formik.setFieldValue(
                                        "interview_type",
                                        x.name
                                      );
                                      currentStage.interview_type = x.name;
                                      await setCurrentInterviewType(x.name);
                                      let uniq_member_emails = [];
                                      let uniq_member_initials = [];
                                      formik.values.job_meeting_details_attributes.map(
                                        (x) => {
                                          if (
                                            !x._destroy &&
                                            x.member_emails.length > 0
                                          ) {
                                            x.member_emails.map(
                                              (
                                                member_email,
                                                member_email_index
                                              ) => {
                                                if (
                                                  !uniq_member_emails.includes(
                                                    member_email
                                                  )
                                                ) {
                                                  uniq_member_emails.push(
                                                    member_email
                                                  );
                                                  uniq_member_initials.push(
                                                    x.member_initials[
                                                      member_email_index
                                                    ]
                                                  );
                                                }
                                                return member_email;
                                              }
                                            );
                                          }
                                          x._destroy = true;
                                          return x;
                                        }
                                      );
                                      if (
                                        old_interview_type &&
                                        old_interview_type ==
                                          INTERVIEW_TYPES.TECHTEST
                                      ) {
                                        uniq_member_emails =
                                          formik.values
                                            .job_test_detail_attributes
                                            .member_emails;
                                        uniq_member_initials =
                                          formik.values
                                            .job_test_detail_attributes
                                            .member_initials;
                                      }
                                      if (
                                        old_interview_type &&
                                        old_interview_type ==
                                          INTERVIEW_TYPES.VIDEOQA
                                      ) {
                                        uniq_member_emails =
                                          formik.values.videoqa.member_emails;
                                        uniq_member_initials =
                                          formik.values.videoqa.member_initials;
                                      }
                                      if (
                                        [
                                          INTERVIEW_TYPES.PHONE,
                                          INTERVIEW_TYPES.VIDEO,
                                          INTERVIEW_TYPES.FACE2FACE,
                                        ].includes(x.name)
                                      )
                                        onAutomationChange(
                                          formik,
                                          "add",
                                          undefined,
                                          currentStage,
                                          setStageEmail,
                                          setInterviewStageCount,
                                          setTotalDuration,
                                          setShowHideButton,
                                          uniq_member_emails,
                                          uniq_member_initials
                                        );
                                      if (x.name == INTERVIEW_TYPES.TECHTEST) {
                                        await setValidationData({
                                          type: "TestLibrary",
                                          test_id: "",
                                        });
                                        await formik.setFieldValue(
                                          "job_test_detail_attributes",
                                          defaultTestDetail(
                                            uniq_member_emails,
                                            uniq_member_initials
                                          )
                                        );
                                      }
                                      if (x.name == INTERVIEW_TYPES.VIDEOQA) {
                                        let videoqa = {
                                          member_emails: uniq_member_emails,
                                          member_initials: uniq_member_initials,
                                        };
                                        formik.setFieldValue(
                                          "videoqa",
                                          videoqa
                                        );
                                      }
                                    }
                                  }}
                                />
                                <label
                                  htmlFor={`icon${interviewIndex}`}
                                  className={`labelcolor`}
                                >
                                  {interviewSwitchButton(x.name)}
                                </label>
                              </p>
                            </Tooltip>
                          </div>
                        );
                      })}
                    </div>
                    <div>
                      <CustomAutocompleteError
                        name={"interview_type_id"}
                        errorClass={PageStyle.Form__Error}
                        custom_class={`FieldError`}
                        formik={formik}
                        style={InputError(formik, "interview_type_id")}
                      />
                    </div>
                  </div>
                  {current_interview_type == INTERVIEW_TYPES.VIDEOQA ? (
                    <div>
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                      >
                        <label
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `videoqa.member_emails`)}
                        >
                          {t("modal:input:members")}
                        </label>
                        <Autosuggest
                          suggestions={users}
                          onSuggestionsFetchRequested={({ value }) =>
                            onSuggestionsFetchRequested(
                              value,
                              currentStage,
                              setUsers,
                              router
                            )
                          }
                          onSuggestionsClearRequested={() => setUsers([])}
                          getSuggestionValue={(suggestion) =>
                            `${suggestion.user_attributes.email}`
                          }
                          renderSuggestion={renderSuggestion}
                          renderInputComponent={
                            videoQaAction.renderMemberInputComponent
                          }
                          shouldRenderSuggestions={
                            videoQaAction.shouldRenderSuggestions
                          }
                          onSuggestionSelected={(event, { suggestion }) => {
                            if (suggestion.user_attributes.email.length > 0) {
                              setTechStageEmail({ value: "" });
                              videoQaAction.onSuggestionSelection(
                                formik,
                                formik.values.videoqa.member_emails,
                                suggestion.user_attributes.email,
                                formik.values.videoqa.member_initials,
                                {
                                  email: suggestion.user_attributes.email,
                                  name_initials:
                                    suggestion.user_attributes.name_initials,
                                  name: suggestion.user_attributes.name,
                                }
                              );
                              formik.validateForm();
                            }
                          }}
                          inputProps={{
                            className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                            placeholder: t('placeholder:search:type_name'),
                            style: InputError(formik, `videoqa.member_emails`),
                            value: techStageEmail.value,
                            disabled: !editable,
                            editable: editable,
                            formik: formik,
                            selectedValues: formik.values.videoqa?.member_initials,
                            closeIcon: <Close/>,
                            videoQaAction: videoQaAction,
                            add_button: true,
                            name: `videoqa.member_emails`,
                            onChange: (value, { newValue, method }) => {
                              setTechStageEmail({
                                value: newValue,
                                error: "",
                              });
                            },
                            setStageEmail: setTechStageEmail,
                            onKeyDown: (event) =>
                              videoQaAction.handleKeyDown(
                                event,
                                formik,
                                setTechStageEmail
                              ),
                          }}
                        ></Autosuggest>
                        <CustomAutocompleteError
                          name={`videoqa.member_emails`}
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          style={InputError(formik, `videoqa.member_emails`)}
                        />
                      </div>

                      {/* ----------------- VIDEO QA Members DIV */}

                      <div
                        className={`${AutomationStyle.AutomationPopup__Row} mt30`}
                      >
                        <div
                          className={`${AutomationStyle.AutomationPopup__w50} mb10`}
                        >
                          {/* ----------------- LANGUAGE DIV -----------------*/}
                          <div
                            className={`${AutomationStyle.InterviewType__SetupVideoQa2} ${PageStyle.Form__TableCol}`}
                          >
                            <div
                              className={`${gridClass(
                                current_interview_type
                              )} mb0`}
                            >
                              <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `language`)}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:language')}</label>
                            </div>
                            <div
                              className={`${AutomationStyle.AutomationPopup__Field}`}
                            >
                              <FormikControl
                                className={`${PageStyle.Form__CustomSelect} ${AutomationStyle.Form__CustomSelect}`}
                                control="select"
                                formik={formik}
                                name="language"
                                options={languageListing}
                                placeholder={t('placeholder:select:langugae')}
                                style={InputError(formik, `language`)}
                                default={"English"}
                                onChange={(data) => {
                                  formik.setFieldValue("language", data.value);
                                }}
                              />
                            </div>
                          </div>
                          {/* ----------------- LANGUAGE DIV -----------------*/}
                        </div>
                        <div
                          className={`${AutomationStyle.AutomationPopup__w50}`}
                        >
                          {/* ----------------- INTRO VIDEO DIV -----------------*/}
                          <div
                            className={`${AutomationStyle.InterviewType__SetupVideoQa2}`}
                          >
                            <div
                              className={`${gridClass(
                                current_interview_type
                              )} ${PageStyle.Form__FloatingLabel} mb10`} style={InputError(formik, `video_link`)}
                            >
                              <label>{t('label:intro_video')}</label>
                            </div>
                            <div
                              className={`${AutomationStyle.AutomationPopup__Field}`}
                            >
                              <FormikControl
                                className={`${PageStyle.Form__Input} thresholdmodl`}
                                control="input"
                                type="text"
                                formik={formik}
                                name="video_link"
                                placeholder={
                                  CONSTANTS.texts.placeholder_intro_video
                                }
                                style={InputError(formik, `video_link`)}
                              />
                            </div>
                          </div>
                          {/* ----------------- INTRO VIDEO DIV -----------------*/}
                        </div>
                      </div>
                      {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}
                      <div
                        className={`${AutomationStyle.AutomationPopup__Row}`}
                      >
                        <div
                          className={`${AutomationStyle.AutomationPopup__InterviewQuestion} mt30`}
                        >
                          {formik?.values?.questions_attributes?.map(
                            (question, index) => {
                              return (
                                <div
                                  key={`question_key_${index}`}
                                  className={`${PageStyle.SetupPopup__QuestionSection} ${AutomationStyle.AutomationPopup__QuestionSection}`}
                                >
                                  <h3 className={`Dpflex JustifySpace`}>
                                    {" "}
                                    {t('modal:input:interview_question')} {index + 1}
                                    {formik.values.questions_attributes.length >
                                      1 && (
                                      <Deleteicon
                                       className={`${FormModalStyle.Modal__Container__IconSvg}`}
                                        onClick={() => {
                                          addInterviewManualAction.onDeleteClick(
                                            formik,
                                            index
                                          );
                                        }}
                                      />
                                    )}
                                  </h3>
                                  <div
                                    className={`${AutomationStyle.AutomationPopup__Question} ${PageStyle.Form__TableCol} mt30`}
                                  >
                                    <div
                                      className={`${gridClass(
                                        current_interview_type
                                      )} mb0`}
                                    >
                                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(
                                          formik,
                                          `questions_attributes.${index}.question`
                                        )} style={InputText(formik, `questions_attributes.${index}.question`)}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:question')}</label>
                                    </div>
                                    <div
                                      className={`${AutomationStyle.AutomationPopup__Field}`}
                                    >
                                      <FormikControl
                                        className={`${PageStyle.Form__Input} ${AutomationStyle.Form__Input} input600`}
                                        control="input"
                                        type="text"
                                        formik={formik}
                                        placeholder={
                                          t('placeholder:question')
                                        }
                                        name={`questions_attributes.${index}.question`}
                                        custom_class={`FieldError`}
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.question`
                                        )}
                                        onChange={(data) => {
                                          formik.setFieldValue(
                                            `questions_attributes.${index}.question`,
                                            data.target.value
                                          );
                                          formik.status &&
                                          formik.status[
                                            "questions_attributes"
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ]["question"]
                                            ? delete formik.status[
                                                "questions_attributes"
                                              ][index]["question"]
                                            : "";
                                          formik.setStatus(formik.status);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={`${AutomationStyle.AutomationPopup__Description} ${PageStyle.Form__TableCol} mt30`}
                                  >
                                    <div
                                      className={`${gridClass(
                                        current_interview_type
                                      )}  ${PageStyle.Form__FloatingLabel} mb10`}
                                    >
                                      <label>{t('modal:input:description')}</label>
                                    </div>
                                    <div
                                      className={`${AutomationStyle.AutomationPopup__Field}`}
                                    >
                                      <FormikControl
                                        control="customtextarea"
                                        type="text"
                                        formik={formik}
                                        className={`${PageStyle.Form__Textarea} ${AutomationStyle.Form__Textarea} input600`}
                                        name={`questions_attributes.${index}.description`}
                                        rows="4"
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.description`
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={`Dpflexonly AlignBaseline mt20 ${AutomationStyle.AutomationPopup__TwoFields}`}
                                  >
                                    <div
                                      className={`${AutomationStyle.AutomationPopup__Time} ${PageStyle.Form__TableCol} Dpflexonly AlignBaseline w100 mt20`}
                                    >
                                      <div
                                        className={`${gridClass(
                                          current_interview_type
                                        )} ${PageStyle.Form__FloatingLabel} wauto mb10 mr0`} >
                                        <label  style={{
    ...InputText(formik, `questions_attributes.${index}.answer_time`),
    whiteSpace: 'nowrap'
  }}>
                                         <span className={`red-color`}>*</span> {t('modal:input:time_to_answer')}
                                        </label>
                                      </div>
                                      <div
                                        className={`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius}  w50`}
                                      >
                                        <div className={`Dpflexonly`}>
                                          <Field
                                            component={
                                              addInterviewManualAction.NumberField
                                            }
                                            defaultValue={30}
                                            type="text"
                                            name={`questions_attributes.${index}.answer_time`}
                                            className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} width60 inputerrorheight`}
                                            formik={formik}
                                            format={"###"}
                                            style={InputError(
                                              formik,
                                              `questions_attributes.${index}.answer_time`
                                            )}
                                            onValueChange={(value) => {
                                              formik.setFieldValue(
                                                `questions_attributes.${index}.answer_time`,
                                                value.floatValue
                                              );
                                              formik.status &&
                                              formik.status[
                                                "questions_attributes"
                                              ] &&
                                              formik.status[
                                                "questions_attributes"
                                              ][index] &&
                                              formik.status[
                                                "questions_attributes"
                                              ][index]["answer_time"]
                                                ? delete formik.status[
                                                    "questions_attributes"
                                                  ][index]["answer_time"]
                                                : "";
                                              formik.setStatus(formik.status);
                                            }}
                                          />
                                          <span
                                            className={`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right}`}
                                            style={InputError(formik,`questions_attributes.${index}.answer_time`)}>
                                            {t('modal:input:sec')}
                                          </span>
                                        </div>

                                        <CustomAutocompleteError
                                          name={`questions_attributes.${index}.answer_time`}
                                          errorClass={PageStyle.Form__Error}
                                          formik={formik}
                                          custom_class={`FieldError`}
                                          style={InputError(
                                            formik,
                                            `questions_attributes.${index}.answer_time`
                                          )}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className={`${AutomationStyle.AutomationPopup__Time} ${PageStyle.Form__TableCol} Dpflexonly AlignBaseline JustifyEnd wauto`}
                                    >
                                      <div
                                        className={`${gridClass(
                                          current_interview_type
                                        )} ${PageStyle.Form__FloatingLabel} wauto mb10`} >
                                        <label className={`text-center`} style={InputText(
                                              formik,
                                              `questions_attributes.${index}.attempts`
                                            )}>
                                          <span className={`red-color`}>*</span> {t('modal:input:attempts:number')} &nbsp;

                                        <Tooltip
                                            content={t('modal:input:attempts:max')}
                                            background={"#203040"}
                                            radius={4}
                                            padding={8}
                                            placement="right"
                                            fontSize="12px"
                                            className='SimpleTooltip'
                                          >
                                            <p className={`tooltipwidthinterview140`}>
                                              <Exclamation />
                                            </p>
                                          </Tooltip>
                                          </label>
                                      </div>
                                      <div
                                        className={`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__Attempts__Number} Dpflexonly AlignBaseline w50`}>
                                        <div>
                                          <Field
                                            component={
                                              addInterviewManualAction.NumberField
                                            }
                                            defaultValue={2}
                                            type="text"
                                            name={`questions_attributes.${index}.attempts`}
                                            className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} width100 inputerrorheight text-center`}
                                            formik={formik}
                                            format={"#"}
                                            onValueChange={(value) => {
                                              formik.setFieldValue(
                                                `questions_attributes.${index}.attempts`,
                                                value.floatValue
                                              );
                                              formik.status &&
                                              formik.status[
                                                "questions_attributes"
                                              ] &&
                                              formik.status[
                                                "questions_attributes"
                                              ][index] &&
                                              formik.status[
                                                "questions_attributes"
                                              ][index]["attempts"]
                                                ? delete formik.status[
                                                    "questions_attributes"
                                                  ][index]["attempts"]
                                                : "";
                                              formik.setStatus(formik.status);
                                            }}
                                            style={InputError(
                                              formik,
                                              `questions_attributes.${index}.attempts`
                                            )}
                                          />
                                          <CustomAutocompleteError
                                            name={`questions_attributes.${index}.attempts`}
                                            errorClass={PageStyle.Form__Error}
                                            formik={formik}
                                            style={InputError(
                                              formik,
                                              `questions_attributes.${index}.attempts`
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                      {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}

                      {/* ----------------- ADD QUESTON SECTION -----------------*/}

                      <div
                        className={`${PageStyle.SetupPopup__AddQuestion} ${AutomationStyle.AutomationPopup__AddQuestionButton} ${PageStyle.mt15}`}
                      >
                        <Button
                          buttonstyle={`${ButtonStyle.iconTextButton}`
                          }
                          type="button"
                          disabled={disabledAddMoreQuestion}
                          onClick={() =>
                            addInterviewManualAction.onAddClick(formik)
                          }
                        >
                        <AddIcon />
                          {t('button:add:question')}
                        </Button>
                      </div>
                      {/* ----------------- ADD QUESTON SECTION -----------------*/}

                      {/* ----------------- CUSTOMISATION DIV ----------------- */}
                      <div className="mb30 mt40">
                        <h4
                          className={` ${PageStyle.SetupPopup__ContentBlock} ${AutomationStyle.AutomationPopup__Customisation} mt0`}
                        >
                          {t('modal:automation:customisations')}
                        </h4>
                        <div className={`Dpflex`}>
                          <div
                            className={`${PageStyle.SetupPopup__ContentCustomisation} ${AutomationStyle.AutomationPopup__PracticeScreen} ${PageStyle.SetupPopup__AddInterviewCustomisation}`}
                          >
                            <div className={`thresholdmodl ${AutomationStyle.AutomationPopup__SetupVideoQa3}`}>
                              <h3 className={`Dpflexonly`}>
                               {t('modal:input:practice_screen')}
                                <span
                                  className={`${PageStyle.Interview__BestMatchExclamation} ${AutomationStyle.AutomationPopup__PracticeExclamation}`}
                                >
                                  <Tooltip
                                    content={t('agency:video:practice_question')}
                                    background={"#203040"}
                                    radius={20}
                                    padding={8}
                                    placement="right"
                                    fontSize="12px"
                                    className='SimpleTooltip'
                                  >
                                    <p className={`tooltipwidthinterview200`}>
                                      <PracticeExclamation />
                                    </p>
                                  </Tooltip>
                                </span>
                              </h3>
                              <label
                                className={PageStyle.IntegrationTable__switch}
                              >
                                <input
                                  type="checkbox"
                                  defaultChecked={formik.values.practise_screen}
                                  onChange={(event) => {
                                    formik.setFieldValue(
                                      "practise_screen",
                                      event.target.checked
                                    );
                                  }}
                                />
                                <span
                                  className={`${PageStyle.IntegrationTable__slider} ${PageStyle.IntegrationTable__round} automationslider automationround width44`}
                                ></span>
                              </label>
                            </div>
                          </div>

                          <div
                            className={`${PageStyle.SetupPopup__ContentCustomisation} ${PageStyle.SetupPopup__PushTop} ${PageStyle.SetupPopup__SetupVideoQa4} ${AutomationStyle.AutomationPopup__SetupVideoQa4} ${PageStyle.Form__TableCol}`}
                          >
                            <label
                              className={`Dpflexonly AlignBaseline ${PageStyle.mb15} ${PageStyle.Form__FloatingLabel} mr10`} style={InputText(formik, `expires`)}
                            >
                             <span className={`red-color`}>*</span>  {t('modal:input:expires')}
                            </label>
                            <div
                              className={`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius} w50`}
                            >
                              <div
                                className={`${AutomationStyle.AutomationPopup__NoRightBorderRadius} Dpflexonly`}
                              >
                                <Field
                                  component={
                                    addInterviewManualAction.NumberField
                                  }
                                  type="text"
                                  name={"expires"}
                                  className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} thresholdmodl width70`}
                                  formik={formik}
                                  format={"###"}
                                  style={InputError(formik, `expires`)}
                                  defaultValue={2}
                                  onValueChange={(value) => {
                                    formik.setFieldValue(
                                      `expires`,
                                      value.floatValue
                                    );
                                    formik.setStatus["expires"] = "";
                                  }}
                                />
                                <span
                                  className={`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right} ml0`}
                                  style={InputError(formik, `expires`)}>
                                  days
                                </span>
                              </div>
                              <CustomAutocompleteError
                                name={"expires"}
                                errorClass={PageStyle.Form__Error}
                                formik={formik}
                                custom_class={`FieldError`}
                                style={InputError(formik, `expires`)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ----------------- CUSTOMISATION DIV ----------------- */}
                    </div>
                  ) : (
                    <div>
                      <FieldArray
                        className={``}
                        name="job_meeting_details_attributes"
                        render={(arrayHelpers) => {
                          return formik.values.job_meeting_details_attributes.map(
                            (item, index) => {
                              return (
                                !item._destroy && (
                                  <>
                                    {/* Interview Type Phone */}

                                    {current_interview_type ==
                                      INTERVIEW_TYPES.PHONE && (
                                      <>
                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                                        >
                                          <label
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                                            style={InputText(formik,`job_meeting_details_attributes.${index}.member_emails`)}>
                                            <span className={`red-color`}>*</span>&nbsp;{t(
                                              "modal:input:members"
                                            )}

                                          </label>
                                          <Autosuggest
                                            suggestions={users}
                                            onSuggestionsFetchRequested={({
                                              value,
                                            }) =>
                                              onSuggestionsFetchRequested(
                                                value,
                                                currentStage,
                                                setUsers,
                                                router
                                              )
                                            }
                                            onSuggestionsClearRequested={() =>
                                              setUsers([])
                                            }
                                            getSuggestionValue={(suggestion) =>
                                              `${suggestion.user_attributes.email}`
                                            }
                                            renderSuggestion={renderSuggestion}
                                            renderInputComponent={
                                              renderAutomationModalInputComponent
                                            }
                                            shouldRenderSuggestions={
                                              shouldRenderSuggestions
                                            }
                                            onSuggestionSelected={(
                                              event,
                                              { suggestion }
                                            ) => {
                                              if (
                                                suggestion.user_attributes.email
                                                  .length > 0
                                              ) {
                                                stageEmail[index] = {
                                                  value: "",
                                                };
                                                setStageEmail([...stageEmail]);
                                                onSuggestionSelection(
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_emails,
                                                  suggestion.user_attributes
                                                    .email,
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_initials,
                                                  {
                                                    email:
                                                      suggestion.user_attributes
                                                        .email,
                                                    name_initials:
                                                      suggestion.user_attributes
                                                        .name_initials,
                                                    name: suggestion
                                                      .user_attributes.name,
                                                  }
                                                );
                                                formik.validateForm();
                                              }
                                            }}
                                            inputProps={{
                                              className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft}`,
                                              placeholder:
                                              t('placeholder:search:type_name'),
                                              styleError: InputError(formik,`job_meeting_details_attributes.${index}.member_emails`),
                                              value: stageEmail[index].value,
                                              index: index,
                                              formik: formik,
                                              selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                              closeIcon: <Close/>,
                                              disabled: !editable,
                                              editable: editable,
                                              name: `job_meeting_details_attributes.${index}.member_emails`,
                                              onChange: (
                                                value,
                                                { newValue, method }
                                              ) => {
                                                stageEmail[index] = {
                                                  value: newValue,
                                                };
                                                setStageEmail([...stageEmail]);
                                              },
                                              stageEmail: stageEmail,
                                              setStageEmail: setStageEmail,
                                              onKeyDown: (event) =>
                                                handleKeyDown(
                                                  event,
                                                  formik,
                                                  index,
                                                  stageEmail,
                                                  setStageEmail
                                                ),
                                            }}
                                          ></Autosuggest>
                                          <CustomAutocompleteError
                                            name={`job_meeting_details_attributes.${index}.member_emails`}
                                            errorClass={PageStyle.Form__Error}
                                            formik={formik}
                                            style={InputError(
                                              formik,
                                              `job_meeting_details_attributes.${index}.member_emails`
                                            )}
                                          />

                                        </div>
                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${AutomationStyle.AutomationPopup__Duration} ${PageStyle.Form__TableCol}`}
                                        >
                                          <label
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style ={InputText(formik,`job_meeting_details_attributes.${index}.duration`)}>
                                            <span className={`red-color`}>*</span>&nbsp;{t(
                                              "modal:input:duration"
                                            )}
                                            <span>
                                              (
                                              {t(
                                                "modal:input:mins"
                                              )}
                                              )
                                            </span>

                                          </label>
                                          <FormikControl
                                            className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                                            control="input"
                                            type="text"
                                            autocomplete="off"
                                            placeholder={t('placeholder:eg:15')}
                                            formik={formik}
                                            maxLength={3}
                                            custom_class={`FieldError`}
                                            name={`job_meeting_details_attributes.${index}.duration`}
                                            value={
                                              formik.values
                                                .job_meeting_details_attributes[
                                                index
                                              ].duration
                                            }
                                            onChange={(evt) => {
                                              let new_value = isNaN(
                                                evt.target.value
                                              )
                                                ? ""
                                                : parseInt(evt.target.value) ==
                                                  0
                                                ? ""
                                                : evt.target.value;
                                              formik.setFieldValue(
                                                `job_meeting_details_attributes.${index}.duration`,
                                                new_value
                                              );
                                              let durations = [];
                                              formik.values.job_meeting_details_attributes.map(
                                                (x, itemIndex) => {
                                                  if (!x._destroy) {
                                                    if (itemIndex == index) {
                                                      durations.push(new_value);
                                                    } else {
                                                      durations.push(
                                                        parseInt(x.duration) ||
                                                          0
                                                      );
                                                    }
                                                  } else {
                                                    durations.push(0);
                                                  }
                                                  return x;
                                                }
                                              );

                                              durations[index] = new_value;
                                              setTotalDuration(
                                                durations.reduce(
                                                  (a, b) =>
                                                    (parseInt(a) || 0) +
                                                    (parseInt(b) || 0),
                                                  0
                                                )
                                              );
                                              let job_meeting_details_attributes =
                                                formik.values
                                                  .job_meeting_details_attributes;
                                            }}
                                            style={InputError(
                                              formik,
                                              `job_meeting_details_attributes.${index}.duration`
                                            )}
                                          ></FormikControl>
                                        </div>
                                      </>
                                    )}

                                    {/* Interview Type Video */}

                                    {current_interview_type ==
                                      INTERVIEW_TYPES.VIDEO && (
                                      <div className={`mt30 ${AutomationStyle.AutomationPopup__FlexFlow}`}>
                                        <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${AutomationStyle.AutomationPopup__InputField} ${PageStyle.Form__TableCol} mb0`}>
                                        <label
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik,`job_meeting_details_attributes.${index}.meeting_platform_attributes.integration_id`)}><span className={`red-color`}>*</span>&nbsp;
                                          {t(
                                            "modal:input:platform"
                                          )}{" "}

                                        </label>
                                        <FormikControl
                                          className={`${PageStyle.Form__CustomSelect} ${PageStyle.width100}`}
                                          control="select"
                                          formik={formik}
                                          placeholder={t('placeholder:select:default')}
                                          options={platforms}
                                          components={{
                                            Option: IconOption,
                                          }}
                                          onChange={(option) =>
                                            formik.setFieldValue(
                                              `job_meeting_details_attributes.${index}.meeting_platform_attributes.integration_id`,
                                              option.value
                                            )
                                          }
                                          default={
                                            formik.values
                                              .job_meeting_details_attributes[
                                              index
                                            ].meeting_platform_attributes
                                              ?.integration_id
                                          }
                                          name={`job_meeting_details_attributes.${index}.meeting_platform_attributes.integration_id`}
                                          style={InputError(
                                            formik,
                                            `job_meeting_details_attributes.${index}.meeting_platform_attributes.integration_id`
                                          )}
                                        />
                                      </div>
                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${AutomationStyle.AutomationPopup__InputField} ${PageStyle.Form__TableCol} mb0`}>

                                          <label
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik,`job_meeting_details_attributes.${index}.duration`)}><span className={`red-color`}>*</span>&nbsp;
                                            {t(
                                              "modal:input:duration"
                                            )}
                                            <span>
                                              (
                                              {t(
                                                "modal:input:mins"
                                              )}
                                              )
                                            </span>

                                          </label>
                                          <FormikControl
                                            className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                                            control="input"
                                            type="text"
                                            autocomplete="off"
                                            placeholder="e g. 15"
                                            formik={formik}
                                            maxLength={3}
                                            custom_class={`FieldError`}
                                            name={`job_meeting_details_attributes.${index}.duration`}
                                            value={
                                              formik.values
                                                .job_meeting_details_attributes[
                                                index
                                              ].duration
                                            }
                                            onChange={(evt) => {
                                              let new_value = isNaN(
                                                evt.target.value
                                              )
                                                ? ""
                                                : parseInt(evt.target.value) ==
                                                  0
                                                ? ""
                                                : evt.target.value;
                                              formik.setFieldValue(
                                                `job_meeting_details_attributes.${index}.duration`,
                                                new_value
                                              );
                                              let durations = [];
                                              formik.values.job_meeting_details_attributes.map(
                                                (x, itemIndex) => {
                                                  if (!x._destroy) {
                                                    if (itemIndex == index) {
                                                      durations.push(new_value);
                                                    } else {
                                                      durations.push(
                                                        parseInt(x.duration) ||
                                                          0
                                                      );
                                                    }
                                                  } else {
                                                    durations.push(0);
                                                  }
                                                  return x;
                                                }
                                              );

                                              durations[index] = new_value;
                                              setTotalDuration(
                                                durations.reduce(
                                                  (a, b) =>
                                                    (parseInt(a) || 0) +
                                                    (parseInt(b) || 0),
                                                  0
                                                )
                                              );
                                              let job_meeting_details_attributes =
                                                formik.values
                                                  .job_meeting_details_attributes;
                                            }}
                                            style={InputError(
                                              formik,
                                              `job_meeting_details_attributes.${index}.duration`
                                            )}
                                          ></FormikControl>
                                        </div>

                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                                        >
                                          <label
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                                          style = {InputText(formik,`job_meeting_details_attributes.${index}.member_emails`)}><span className={`red-color`}>*</span>&nbsp;
                                            {t(
                                              "modal:input:members"
                                            )}{" "}

                                          </label>
                                          <Autosuggest
                                            suggestions={users}
                                            onSuggestionsFetchRequested={({
                                              value,
                                            }) =>
                                              onSuggestionsFetchRequested(
                                                value,
                                                currentStage,
                                                setUsers,
                                                router
                                              )
                                            }
                                            onSuggestionsClearRequested={() =>
                                              setUsers([])
                                            }
                                            getSuggestionValue={(suggestion) =>
                                              `${suggestion.user_attributes.email}`
                                            }
                                            renderSuggestion={renderSuggestion}
                                            renderInputComponent={
                                              renderInputComponent
                                            }
                                            shouldRenderSuggestions={
                                              shouldRenderSuggestions
                                            }
                                            onSuggestionSelected={(
                                              event,
                                              { suggestion }
                                            ) => {
                                              if (
                                                suggestion.user_attributes.email
                                                  .length > 0
                                              ) {
                                                stageEmail[index] = {
                                                  value: "",
                                                };
                                                setStageEmail([...stageEmail]);
                                                onSuggestionSelection(
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_emails,
                                                  suggestion.user_attributes
                                                    .email,
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_initials,
                                                  {
                                                    email:
                                                      suggestion.user_attributes
                                                        .email,
                                                    name_initials:
                                                      suggestion.user_attributes
                                                        .name_initials,
                                                    name: suggestion
                                                      .user_attributes.name,
                                                  }
                                                );
                                                formik.validateForm();
                                              }
                                            }}
                                            inputProps={{
                                              className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                                              placeholder:
                                              t('placeholder:search:type_name'),
                                              value: stageEmail[index].value,
                                              index: index,
                                              formik: formik,
                                              selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                              closeIcon: <Close/>,
                                              disabled: !editable,
                                              editable: editable,
                                              name: `job_meeting_details_attributes.${index}.member_emails`,
                                              onChange: (
                                                value,
                                                { newValue, method }
                                              ) => {
                                                stageEmail[index] = {
                                                  value: newValue,
                                                };
                                                setStageEmail([...stageEmail]);
                                              },
                                              stageEmail: stageEmail,
                                              setStageEmail: setStageEmail,
                                              onKeyDown: (event) =>
                                                handleKeyDown(
                                                  event,
                                                  formik,
                                                  index,
                                                  stageEmail,
                                                  setStageEmail
                                                ),
                                              styleError :InputError(formik,`job_meeting_details_attributes.${index}.member_emails`)
                                            }}
                                          ></Autosuggest>
                                          <CustomAutocompleteError
                                            name={`job_meeting_details_attributes.${index}.member_emails`}
                                            errorClass={PageStyle.Form__Error}
                                            formik={formik}
                                            style={InputError(
                                              formik,
                                              `job_meeting_details_attributes.${index}.member_emails`
                                            )}
                                          />
                                        </div>
                                        <div
                                          className={`${AutomationStyle.AutomationPopup__CloseIcon}`}
                                        >
                                          {interviewStageCount != 1 && (
                                            <img
                                              src="/icons/close.png"
                                              alt=""
                                              className={`mt0`}
                                              onClick={() =>
                                                onAutomationChange(
                                                  formik,
                                                  "remove",
                                                  index,
                                                  currentStage,
                                                  setStageEmail,
                                                  setInterviewStageCount,
                                                  setTotalDuration,
                                                  setShowHideButton,
                                                  [],
                                                  []
                                                )
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Interview Type Face2Face */}
                                    {current_interview_type ==
                                      INTERVIEW_TYPES.FACE2FACE && (
                                      <div className={`mt0 ${AutomationStyle.AutomationPopup__FlexFlow}`}>
                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer}`}
                                        >
                                          <div
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`}
                                          >
                                            <label
                                              className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                                            style={InputText(
                                                formik,
                                                "default_location"
                                              )}>
                                              <span className={`red-color`}>*</span>&nbsp;{t('label:location')}
                                            </label>
                                            <PlaceAutoComplete
                                              value={
                                                formik.values.default_location
                                              }
                                              onChange={(value) => {
                                                formik.setFieldValue(
                                                  "default_location",
                                                  value
                                                );
                                                formik.setFieldValue(
                                                  "place_id",
                                                  ""
                                                );
                                              }}
                                              onSelect={(
                                                address,
                                                placeId,
                                                suggestion
                                              ) => {
                                                formik.setFieldValue(
                                                  "default_location",
                                                  address
                                                );
                                                formik.setFieldValue(
                                                  "place_id",
                                                  placeId
                                                );
                                              }}
                                              shouldFetchSuggestions={
                                                formik.values.default_location
                                                  .length >= 3
                                              }
                                            >
                                              {({
                                                getInputProps,
                                                getSuggestionItemProps,
                                                suggestions,
                                                loading,
                                              }) => (
                                                <div className="autocomplete-root">
                                                  <input
                                                    className={
                                                      PageStyle.Form__Input
                                                    }
                                                    name={`default_location`}
                                                    placeholder={t('placeholder:eg:london')}
                                                    style={InputError(
                                                      formik,
                                                      `default_location`
                                                    )}
                                                    {...getInputProps({
                                                      disabled:
                                                        !editable ||
                                                        isLocationDisabled(
                                                          formik,
                                                          index
                                                        ),
                                                    })}
                                                  />
                                                  <div className="autocomplete-dropdown-container">
                                                    {loading && (
                                                      <div>{t('loading')}</div>
                                                    )}
                                                    {suggestions.map(
                                                      (suggestion) => (
                                                        <div
                                                          key={
                                                            suggestion.placeId
                                                          }
                                                          {...getSuggestionItemProps(
                                                            suggestion
                                                          )}
                                                        >
                                                          <span
                                                            key={suggestion.id}
                                                          >
                                                            {
                                                              suggestion.description
                                                            }
                                                          </span>
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </PlaceAutoComplete>
                                            <CustomAutocompleteError
                                              name={"default_location"}
                                              errorClass={PageStyle.Form__Error}
                                              custom_class={`FieldError`}
                                              formik={formik}
                                              style={InputError(
                                                formik,
                                                "default_location"
                                              )}
                                              custom_error_90={
                                                "custom_error_90"
                                              }
                                            />
                                          </div>
                                          <div
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`}
                                          >
                                            <label
                                              className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                                            style={InputText(
                                                  formik,
                                                  `job_meeting_details_attributes.${index}.duration`
                                                )}><span className="red-color">*</span>&nbsp;
                                              {t(
                                                "modal:input:duration"
                                              )}
                                              <span>
                                                (
                                                {t(
                                                  "modal:input:mins"
                                                )}
                                                )
                                              </span>

                                            </label>
                                            <div
                                              className={`${AutomationStyle.AutomationPopup__Field}`}
                                            >
                                              <FormikControl
                                                className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                                                control="input"
                                                type="text"
                                                autocomplete="off"
                                                placeholder="e g. 15"
                                                formik={formik}
                                                maxLength={3}
                                                custom_class={`FieldError`}
                                                name={`job_meeting_details_attributes.${index}.duration`}
                                                value={
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].duration
                                                }
                                                onChange={(evt) => {
                                                  let new_value = isNaN(
                                                    evt.target.value
                                                  )
                                                    ? ""
                                                    : parseInt(
                                                        evt.target.value
                                                      ) == 0
                                                    ? ""
                                                    : evt.target.value;
                                                  formik.setFieldValue(
                                                    `job_meeting_details_attributes.${index}.duration`,
                                                    new_value
                                                  );
                                                  let durations = [];
                                                  formik.values.job_meeting_details_attributes.map(
                                                    (x, itemIndex) => {
                                                      if (!x._destroy) {
                                                        if (
                                                          itemIndex == index
                                                        ) {
                                                          durations.push(
                                                            new_value
                                                          );
                                                        } else {
                                                          durations.push(
                                                            parseInt(
                                                              x.duration
                                                            ) || 0
                                                          );
                                                        }
                                                      } else {
                                                        durations.push(0);
                                                      }
                                                      return x;
                                                    }
                                                  );
                                                  durations[index] = new_value;
                                                  setTotalDuration(
                                                    durations.reduce(
                                                      (a, b) =>
                                                        (parseInt(a) || 0) +
                                                        (parseInt(b) || 0),
                                                      0
                                                    )
                                                  );
                                                  let job_meeting_details_attributes =
                                                    formik.values
                                                      .job_meeting_details_attributes;
                                                }}
                                                style={InputError(
                                                  formik,
                                                  `job_meeting_details_attributes.${index}.duration`
                                                )}
                                              ></FormikControl>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                                        >
                                          <label
                                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                                          style={InputText(
                                              formik,
                                              `job_meeting_details_attributes.${index}.member_emails`
                                            )}><span className={`red-color`}>*</span>&nbsp;
                                            {t(
                                              "modal:input:members"
                                            )}

                                          </label>
                                          <Autosuggest
                                            suggestions={users}
                                            onSuggestionsFetchRequested={({
                                              value,
                                            }) =>
                                              onSuggestionsFetchRequested(
                                                value,
                                                currentStage,
                                                setUsers,
                                                router
                                              )
                                            }
                                            onSuggestionsClearRequested={() =>
                                              setUsers([])
                                            }
                                            getSuggestionValue={(suggestion) =>
                                              `${suggestion.user_attributes.email}`
                                            }
                                            renderSuggestion={renderSuggestion}
                                            renderInputComponent={
                                              renderAutomationModalInputComponent
                                            }
                                            shouldRenderSuggestions={
                                              shouldRenderSuggestions
                                            }
                                            onSuggestionSelected={(
                                              event,
                                              { suggestion }
                                            ) => {
                                              if (
                                                suggestion.user_attributes.email
                                                  .length > 0
                                              ) {
                                                stageEmail[index] = {
                                                  value: "",
                                                };
                                                setStageEmail([...stageEmail]);
                                                onSuggestionSelection(
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_emails,
                                                  suggestion.user_attributes
                                                    .email,
                                                  formik.values
                                                    .job_meeting_details_attributes[
                                                    index
                                                  ].member_initials,
                                                  {
                                                    email:
                                                      suggestion.user_attributes
                                                        .email,
                                                    name_initials:
                                                      suggestion.user_attributes
                                                        .name_initials,
                                                    name: suggestion
                                                      .user_attributes.name,
                                                  }
                                                );
                                                formik.validateForm();
                                              }
                                            }}
                                            inputProps={{
                                              className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                                              placeholder:
                                              t('placeholder:search:type_name'),
                                              value: stageEmail[index].value,
                                              index: index,
                                              formik: formik,
                                              selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                              closeIcon: <Close/>,
                                              styleError: InputError(formik, `job_meeting_details_attributes.${index}.member_emails`),
                                              disabled: !editable,
                                              editable: editable,
                                              name: `job_meeting_details_attributes.${index}.member_emails`,
                                              onChange: (
                                                value,
                                                { newValue, method }
                                              ) => {
                                                stageEmail[index] = {
                                                  value: newValue,
                                                };
                                                setStageEmail([...stageEmail]);
                                              },
                                              stageEmail: stageEmail,
                                              setStageEmail: setStageEmail,
                                              onKeyDown: (event) =>
                                                handleKeyDown(
                                                  event,
                                                  formik,
                                                  index,
                                                  stageEmail,
                                                  setStageEmail
                                                ),
                                            }}
                                          ></Autosuggest>
                                          <CustomAutocompleteError
                                            name={`job_meeting_details_attributes.${index}.member_emails`}
                                            errorClass={PageStyle.Form__Error}
                                            formik={formik}
                                            style={InputError(
                                              formik,
                                              `job_meeting_details_attributes.${index}.member_emails`
                                            )}
                                          />

                                        </div>
                                        <div className={`${AutomationStyle.AutomationPopup__CloseIcon}`}>
                                          {interviewStageCount != 1 && (
                                            <img
                                              src="/icons/close.png"
                                              alt=""
                                              className={`mt0`}
                                              onClick={() =>
                                                onAutomationChange(
                                                  formik,
                                                  "remove",
                                                  index,
                                                  currentStage,
                                                  setStageEmail,
                                                  setInterviewStageCount,
                                                  setTotalDuration,
                                                  setShowHideButton,
                                                  [],
                                                  []
                                                )
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )
                              );
                            }
                          );
                        }}
                      ></FieldArray>

                      <div className={`dnone ${PageStyle.addbtnposition} mt25`}>
                        {formik.values.interview_type_id &&
                          [
                            INTERVIEW_TYPES.VIDEO,
                            INTERVIEW_TYPES.FACE2FACE,
                          ].includes(current_interview_type) &&
                          showHideButton && (
                            <div className={`w-auto`}>
                              <Button
                                buttonstyle={`${ButtonStyle.iconTextButton} mt0`}
                                type="button"
                                onClick={() => {
                                  onAutomationChange(
                                    formik,
                                    "add",
                                    undefined,
                                    currentStage,
                                    setStageEmail,
                                    setInterviewStageCount,
                                    setTotalDuration,
                                    setShowHideButton,
                                    [],
                                    []
                                  );
                                }}
                              >
                              <AddIcon />
                                {t('button:add:interview')}
                              </Button>
                            </div>
                          )}
                      </div>
                      {formik.values.interview_type_id &&
                        [
                          INTERVIEW_TYPES.PHONE,
                          INTERVIEW_TYPES.VIDEO,
                          INTERVIEW_TYPES.FACE2FACE,
                        ].includes(current_interview_type) && (
                          <div
                            className={`${PageStyle.SetupPopup__Duration} ${AutomationStyle.AutomationPopup__TotalDuration}`}
                          >
                            <h3> {t('modal:input:total_duration')}</h3>
                            <span>
                              {totalDuration}{" "}
                              {t("modal:input:mins")}
                            </span>
                          </div>
                        )}
                    </div>
                  )}
                  {current_interview_type == INTERVIEW_TYPES.TECHTEST && (
                    <div className={`${PageStyle.SetupPopup__ContentBlock} mt5`}>
                      <div
                        className={`${AutomationStyle.AutomationPopup__Row}`}
                      >
                        <div
                          className={`${AutomationStyle.AutomationPopup__Members}`}
                        >
                          <div
                            className={`${gridClass(
                              current_interview_type
                            )} ${PageStyle.Form__FloatingLabel} mb10`}
                          >
                            <label>
                              {t("modal:input:members")}
                            </label>
                          </div>
                          <div
                            className={`${AutomationStyle.AutomationPopup__Field}`}
                          >
                            <Autosuggest
                              suggestions={users}
                              onSuggestionsFetchRequested={({ value }) =>
                                onSuggestionsFetchRequested(
                                  value,
                                  currentStage,
                                  setUsers,
                                  router
                                )
                              }
                              onSuggestionsClearRequested={() => setUsers([])}
                              getSuggestionValue={(suggestion) =>
                                `${suggestion.user_attributes.email}`
                              }
                              renderSuggestion={renderSuggestion}
                              renderInputComponent={
                                techTestAction.renderMemberInputComponent
                              }
                              shouldRenderSuggestions={
                                techTestAction.shouldRenderSuggestions
                              }
                              onSuggestionSelected={(event, { suggestion }) => {
                                if (
                                  suggestion.user_attributes.email.length > 0
                                ) {
                                  setTechStageEmail({ value: "" });
                                  techTestAction.onSuggestionSelection(
                                    formik.values.job_test_detail_attributes
                                      .member_emails,
                                    suggestion.user_attributes.email,
                                    formik.values.job_test_detail_attributes
                                      .member_initials,
                                    {
                                      email: suggestion.user_attributes.email,
                                      name_initials:
                                        suggestion.user_attributes
                                          .name_initials,
                                      name: suggestion.user_attributes.name,
                                    }
                                  );
                                  formik.validateForm();
                                }
                              }}
                              inputProps={{
                                className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                                placeholder: t('placeholder:search:type_name'),
                                value: techStageEmail.value,
                                disabled: !editable,
                                editable: editable,
                                formik: formik,
                                selectedValues: formik.values.job_test_detail_attributes?.member_initials,
                                closeIcon: <Close/>,
                                techTestAction: techTestAction,
                                add_button: true,
                                name: `job_test_detail_attributes.member_emails`,
                                onChange: (value, { newValue, method }) => {
                                  setTechStageEmail({
                                    value: newValue,
                                    error: "",
                                  });
                                },
                                setStageEmail: setTechStageEmail,
                                onKeyDown: (event) =>
                                  techTestAction.handleKeyDown(
                                    event,
                                    formik,
                                    setTechStageEmail
                                  ),
                              }}
                            ></Autosuggest>
                            <CustomAutocompleteError
                              name={`job_test_detail_attributes.member_emails`}
                              errorClass={PageStyle.Form__Error}
                              formik={formik}
                              style={InputError(
                                formik,
                                `job_test_detail_attributes.member_emails`
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {current_interview_type == INTERVIEW_TYPES.TECHTEST && (
                    <>
{/*                       <div */}
{/*                         className={`${FormModalStyle.Modal__Container__ContentSection__Block}`} */}
{/*                       > */}
{/*                         <div className={` WrapperRadioGrid`}> */}
{/*                           <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                             <Field */}
{/*                               type="radio" */}
{/*                               name="job_test_detail_attributes.test_type" */}
{/*                               id="test_type_1" */}
{/*                               value={"TestLibrary"} */}
{/*                               checked={ */}
{/*                                 formik.values.job_test_detail_attributes */}
{/*                                   ?.test_type == "TestLibrary" */}
{/*                               } */}
{/*                               onChange={(event) => */}
{/*                                 techTestAction.onOptionChange( */}
{/*                                   formik, */}
{/*                                   event, */}
{/*                                   setTechTest, */}
{/*                                   validationData, */}
{/*                                   setValidationData, */}
{/*                                   "original" */}
{/*                                 ) */}
{/*                               } */}
{/*                             /> */}
{/*                             <span */}
{/*                               className="WrapperRadiocheckmark ml0" */}
{/*                               style={{ marginTop: "0" }} */}
{/*                             ></span> */}
{/*                             <span className={`ml5 WrapperRadioSpan fw500`}> */}
{/*                               {" "} */}
{/*                               {t('modal:input:ikm_tech_test')} */}
{/*                             </span> */}
{/*                           </label> */}
{/*  */}
{/*                           <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                             <Field */}
{/*                               type="radio" */}
{/*                               name="job_test_detail_attributes.test_type" */}
{/*                               id="test_type_2" */}
{/*                               value={"Assessment"} */}
{/*                               checked={ */}
{/*                                 formik.values.job_test_detail_attributes */}
{/*                                   ?.test_type == "Assessment" */}
{/*                               } */}
{/*                               onChange={(event) => */}
{/*                                 techTestAction.onOptionChange( */}
{/*                                   formik, */}
{/*                                   event, */}
{/*                                   setTechTest, */}
{/*                                   validationData, */}
{/*                                   setValidationData, */}
{/*                                   "original" */}
{/*                                 ) */}
{/*                               } */}
{/*                             /> */}
{/*                             <span */}
{/*                               className="WrapperRadiocheckmark ml0" */}
{/*                               style={{ marginTop: "0" }} */}
{/*                             ></span> */}
{/*                             <span className={`ml5 WrapperRadioSpan fw500`}> */}
{/*                               {t('modal:input:your_tech_test')} */}
{/*                             </span> */}
{/*                           </label> */}
{/*                         </div> */}
{/*                         {validationData.type == "TestLibrary" && ( */}
{/*                           <div */}
{/*                             className={`${FormModalStyle.Modal__Container__ContentSection__Description} mt-0 `} */}
{/*                           > */}
{/*                            {t('modal:automation:which_assessment_to_send')} */}
{/*                             <a */}
{/*                               href="https://ikmnet.com/products/skills-assessments/" */}
{/*                               target="_blank" */}
{/*                               className={ */}
{/*                                 FormModalStyle.Modal__Container__ContentSection__Description__Link */}
{/*                               } */}
{/*                             > */}
{/*                              {t('click_here')} */}
{/*                             </a>{" "} */}
{/*                             {t('for_help_guide')} */}
{/*                           </div> */}
{/*                         )} */}
{/*                       </div> */}
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer}`}
                      >
                        <div
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`}
                        >
                          <label
                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                          style={InputText(formik,"job_test_detail_attributes.test_id")}>
                            <span className={`red-color`}>*</span>&nbsp;{t('modal:input:test_name')}{" "}

                          </label>
                          <Autosuggest
                            suggestions={tests}
                            onSuggestionsFetchRequested={(value) =>
                              techTestAction.onSuggestionsFetchRequested(
                                value,
                                techTestAction,
                                formik.values.job_test_detail_attributes
                                  .test_type,
                                false, t
                              )
                            }
                            onSuggestionsClearRequested={() => setTests([])}
                            getSuggestionValue={
                              techTestAction.getSuggestionValue
                            }
                            renderSuggestion={techTestAction.renderSuggestion}
                            renderInputComponent={
                              techTestAction.renderInputComponent
                            }
                            shouldRenderSuggestions={() =>
                              formik.values.job_test_detail_attributes
                                .test_type == "Assessment"
                                ? true
                                : techTestAction.shouldRenderSuggestions
                            }
                            onSuggestionSelected={(event, { suggestion }) => {
                              setTechTest(suggestion.name);
                              formik.setFieldValue(
                                "job_test_detail_attributes.test_id",
                                suggestion.id
                              );
                              techTestAction.setCustomTestOptions(
                                formik,
                                suggestion.id.toString(),
                                validationData,
                                setValidationData
                              );
                            }}
                            inputProps={{
                              className: `${PageStyle.Form__Input} input350`,
                              placeholder:t(
                                "placeholder:eg:java_test"
                              ),
                              styleError: InputError(formik,"job_test_detail_attributes.test_id"),
                              value: techTest,
                              disabled: !props.editable,
                              onChange: (value, { newValue, method }) => {
                                setTechTest(newValue);
                                formik.setFieldValue(
                                  "job_test_detail_attributes.test_id",
                                  ""
                                );
                              },
                              name: "job_test_detail_attributes.test_id",
                            }}
                          ></Autosuggest>
                          <CustomAutocompleteError
                            name="job_test_detail_attributes.test_id"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            custom_class={`FieldError`}
                            style={InputError(
                              formik,
                              "job_test_detail_attributes.test_id"
                            )}
                          />
                        </div>
                        <div
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`}
                        >
                          <label
                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik,"job_test_detail_attributes.days_to_expire")}>
                            <span className={`red-color`}>*</span>&nbsp;{t('modal:input:expires')}{" "}

                          </label>
                          <div
                            className={`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius} w50`}
                          >
                            <div
                              className={`${AutomationStyle.AutomationPopup__NoRightBorderRadius} Dpflexonly`}
                            >
                              <Field
                                component={addInterviewManualAction.NumberField}
                                type="text"
                                autocomplete="off"
                                placeholder="e g. 5"
                                className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} thresholdmodl width70`}
                                formik={formik}
                                maxLength={2}
                                name="job_test_detail_attributes.days_to_expire"
                                format={"###"}
                                style={InputError(
                                  formik,
                                  "job_test_detail_attributes.days_to_expire"
                                )}
                                onChange={(evt) => {
                                  let new_value = isNaN(evt.target.value)
                                    ? 1
                                    : parseInt(evt.target.value) == 0
                                    ? ""
                                    : evt.target.value;
                                  formik.setFieldValue(
                                    "job_test_detail_attributes.days_to_expire",
                                    new_value
                                  );
                                  return new_value;
                                }}
                              />
                              <span
                                className={`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right} ml0`}
                                style={InputError(
                                  formik,
                                  "job_test_detail_attributes.days_to_expire"
                                )}
                              >
                                {t('modal:input:days')}
                              </span>
                            </div>
                            <CustomAutocompleteError
                              name="job_test_detail_attributes.days_to_expire"
                              errorClass={PageStyle.Form__Error}
                              formik={formik}
                              custom_class={`FieldError`}
                              style={InputError(
                                formik,
                                "job_test_detail_attributes.days_to_expire"
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      {formik.values.job_test_detail_attributes?.test_id?.toString() ==
                        "upload_new_test" && (
                        <div
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                        >
                          {/* <div
                            className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt25}`}
                          > */}
                          {/* <div
                              className={`${PageStyle.SetupPopup__ContentBlock}`}
                            > */}
                          {/* <label
                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`}
                          >
                            {t('modal:input:enter:assessment:name')}
                          </label> */}
                          <div className={PageStyle.Form__TableCol}>
                           <label className={`${PageStyle.Form__FloatingLabel}`} style =   {InputText(formik, "job_test_detail_attributes.assessment.name")}>{t('modal:input:enter:assessment:name')}</label>
                           </div>
                          <FormikControl
                            className={`assesmentlbl ${PageStyle.Form__Input} ${ModalStyle.Form__Input}`}
                            control="input"
                            type="text"
                            errorClass={PageStyle.Form__Error}
                            custom_class={"form_custom_error"}
                            formik={formik}
                            name="job_test_detail_attributes.assessment.name"
                            style={InputError(
                              formik,
                              "job_test_detail_attributes.assessment.name"
                            )}
                          />
                          {/* </div> */}

                          <div
                            className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.Form__TableCol} mt30`}
                          >
                            <label className={`${PageStyle.Form__FloatingLabel}`}>{t('label:assessment:link')}</label>

                          </div>
                            <FormikControl
                              className={`${PageStyle.Form__Input} ${ModalStyle.Form__Input}`}
                              control="input"
                              placeholder={t('placeholder:enter:link')}
                              type="text"
                              formik={formik}
                              name="job_test_detail_attributes.assessment.link"
                              errorClass={PageStyle.Form__Error}
                              custom_class={"form_custom_error"}
                              disabled={false}
                              style={InputError(
                                formik,
                                "job_test_detail_attributes.assessment.link"
                              )}
                              onChange={(event) => {
                                if (
                                  event.target.value.length == 0 &&
                                  formik.values.file
                                ) {
                                  formik.setFieldValue(
                                    "job_test_detail_attributes.assessment.file_type",
                                    "file"
                                  );
                                } else {
                                  formik.setFieldValue(
                                    "job_test_detail_attributes.assessment.file_type",
                                    "link"
                                  );
                                }
                                formik.setFieldValue(
                                  "job_test_detail_attributes.assessment.link",
                                  event.target.value
                                );
                              }}
                            />
                          <div
                            className={`${ModalStyle.DividerOr} ${ModalStyle.AutomationDividerOr}`}
                          >
                          {t("upload:or")}
                          </div>

                          <div
                            className={`UploadAssessment ${ModalStyle.UploadAssessment} ${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt0}`}
                          >
                            <span className={`${ModalStyle.LabelNote}`}>
                            {t('upload:supported_files')}
                            </span>
                            <div className={`${ModalStyle.DropBox} mt10`}>
                          <div className={`${PageStyle.Form__TableCol}`}>
                            <label  className={`${PageStyle.Form__FloatingLabel} mb10`}>{t('upload:assessment')}</label>
                          </div>
                              <div
                                className={`${PageStyle.Form__DropBoxcontainer} ${ModalStyle.Assessment__Form__DropBoxcontainer}`}
                              >
                                <AssessmentDropZone
                                  id="upload_assessment"
                                  type={"automation"}
                                  name={
                                    "job_test_detail_attributes.assessment.file"
                                  }
                                  multiple={false}
                                  formRef={formRef}
                                  formik={formik}
                                  autofill={false}
                                  accept={".pdf, .docx, .doc"}
                                  dropAction={techTestAction}
                                  drop_type={"template"}
                                />
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      )}
                    </>
                  )}
                  <div>
                    {current_interview_type == INTERVIEW_TYPES.TECHTEST &&
                    validationData.type == "Assessment" &&
                    validationData.test_id == "upload_new_test" ? (
                      <div className={`${FormModalStyle.Modal__Container__ButtonSection} mt30`}>
                        <Tooltip
                          content={t('tooltip:test_template')}
                          background={"#00325A"}
                          radius={20}
                          padding={12}
                          placement="top"
                          fontSize="12px"
                          className='SimpleTooltip'
                        >
                          <p className={`SaveTooltip`}>
                            <Button
                              buttonstyle={`${
                                ButtonStyle.primarybtn
                              } ${cursorNone(props.editable)}`}
                              type="button"
                              disabled={!props.editable}
                              onClick={() => {
                                setButtonState("save_and_continue");
                                if (
                                  (formik.values.job_test_detail_attributes
                                    .assessment.link.length > 0 &&
                                    formik.values.job_test_detail_attributes
                                      .assessment.file) ||
                                  (formik.values.job_test_detail_attributes
                                    .assessment.link.length == 0 &&
                                    !formik.values.job_test_detail_attributes
                                      .assessment.file)
                                ) {
                                  customToastrAction.setNormalToastr(
                                    t('errors:assessment_link_error'),
                                    "warning"
                                  );
                                } else {
                                  formik.submitForm();
                                }
                              }}
                            >
                              {t('button:save_and_continue')}
                            </Button>
                          </p>
                        </Tooltip>
                        <Button
                          buttonstyle={`${
                            ButtonStyle.secondarybtnborder
                          } ${cursorNone(props.editable)}`}
                          type="button"
                          disabled={!props.editable}
                          onClick={() => {
                            setButtonState("continue_without_saving");
                            formik.submitForm();
                          }}
                        >
                          {t('button:continue_without_saving')}
                        </Button>
                      </div>
                    ) : (
                      <div className={`${FormModalStyle.Modal__Container__ButtonSection} mt10`}>
                        {[
                          INTERVIEW_TYPES.PHONE,
                          INTERVIEW_TYPES.FACE2FACE,
                          INTERVIEW_TYPES.VIDEO,
                          INTERVIEW_TYPES.VIDEOQA,
                        ].includes(current_interview_type) && (
                          <Button
                            buttonstyle={`${ButtonStyle.secondarybtn} mr0`}
                            type="button"
                            onClick={async () => {
                              let data = await reviewAutomationEmail(
                                props.job_id || props.jobData.id,
                                router,
                                {
                                  key: "move_candidates",
                                  stage_id: currentStage.id,
                                  list: true,
                                  interview_type_id:
                                    formik.values.interview_type_id,
                                }
                              );
                              props.setEmailData(data);
                              props.setHideModalClass(true);
                              props.emailTemplateInfo.job_stage_id =
                                currentStage.id;
                              props.setEmailTemplateInfo(
                                props.emailTemplateInfo
                              );
                              props.setReviewEmail(true);
                            }}
                          >
                           {t('button:review_email')}
                          </Button>
                        )}
                        <Button
                          buttonstyle={`${ButtonStyle.primarybtn} ${cursorNone(
                            editable
                          )}`}
                          disabled={isDisabled || !editable}
                          type="submit"
                        >
                          {t('button:save')}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

AutomationModal.layout = ClientDashboard;
export default AutomationModal;
